import type { PublicClientApplication } from "@azure/msal-browser";
import type { AuthSettings } from "./authConfig";
import type { initializeTeamsAuth } from "./teamsAuth";

type TeamsAuth = Awaited<ReturnType<typeof initializeTeamsAuth>>;

// Shared auth singletons, assigned once during app bootstrap (see main.tsx).
// These live in their own leaf module rather than being exported from the
// entry (main.tsx). Exporting them from the entry created an import cycle
// (main -> App -> ... -> api.ts/Root.tsx -> main) which caused Vite to
// re-execute the entry on every HMR update, remounting the whole app.
// Consumers read these at call-time, so live bindings are safe.
export let teamsAuth: TeamsAuth;
export let authSettings: AuthSettings;
export let msalInstance: PublicClientApplication;

export function setAuthInstances(
  t: TeamsAuth,
  a: AuthSettings,
  m: PublicClientApplication,
) {
  teamsAuth = t;
  authSettings = a;
  msalInstance = m;
}
